var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVanity = function SvgVanity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#vanity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 15v-1.5h15zM17.5 12a1.5 1.5 0 0 0-1.5-1.5H4A1.5 1.5 0 0 0 2.5 12v1.5h15z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: -0.5,
    y: -0.5,
    rx: 4,
    transform: "matrix(0 -1 -1 0 13.5 8)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.124 2.326C10.891 2.326 12 3 12 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 5 18v-1.5h1.5zM15 18a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-1.5H15z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vanity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgVanity;